import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/ad-free/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/ad-free',
  name: 'activity_ad_free',
  component: Index,
  props: true,
  meta: {
    title: '免广告卡',
  },
}

export default [indexRoute]
